<script setup lang="ts">
import type { INavbarItem } from "@/types"
import footerImg from "@brand-logo-footer"
import { Footer, Navbar } from "@/components"

defineProps<{
  navItems?: INavbarItem[]
}>()
</script>

<template>
  <div class="min-h-screen flex flex-col">
    <header>
      <slot name="navbar">
        <Navbar :items="navItems" :hide-nav-items="!navItems?.length" :image-src="footerImg" />
      </slot>
    </header>
    <main class="grow">
      <div class="grow">
        <slot name="default" />
      </div>
    </main>
    <footer>
      <slot name="footer">
        <Footer />
      </slot>
    </footer>
  </div>
</template>
